import React from 'react';
import { useQuery } from '@apollo/client';
import defaultClasses from './promoBar.css';
import { GET_PROMOBAR } from '@magento/peregrine/lib/talons/PromoBar/promoBar.gql';
import parseStorageHtml from '@magento/pagebuilder/lib/parseStorageHtml';
import Slider from 'react-slick';
import { mergeClasses } from '@magento/venia-ui/lib/classify';
import PromoBarTimer from './PromoBarTimer';
import BBLink from "../BBLink";
import { resourceUrl } from "../../drivers";
var SEPARATOR = '|';
var PromoBar = props => {
  var _data$cmsBlocks;
  var {
    identifiers,
    Data: dataAggregator,
    Carousel: carouselSpeedAggregator
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    data
  } = useQuery(GET_PROMOBAR, {
    variables: {
      identifiers
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    skip: !identifiers || !!dataAggregator
  });
  if (!dataAggregator && !data) {
    return null;
  }
  var items = data === null || data === void 0 || (_data$cmsBlocks = data.cmsBlocks) === null || _data$cmsBlocks === void 0 ? void 0 : _data$cmsBlocks.items;
  var itemsContent = (items === null || items === void 0 ? void 0 : items.length) && parseStorageHtml(items[0].content).children[0].children[0];
  var {
    Data,
    Carousel: CarouselSpeed
  } = itemsContent || props;
  var sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: "".concat(CarouselSpeed) * 1000
  };
  function isDST() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    var july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(january, july) !== date.getTimezoneOffset();
  }

  // mobile
  //  promo title limited to avg 30 character
  // link title limited to avg of 7 character

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.root_slider
  }, /*#__PURE__*/React.createElement(Slider, sliderSettings, Data.promo_bars.map(item => {
    var {
      promo_title,
      link_title,
      text_color,
      bar_background_color,
      record_id,
      promo_end_date,
      promo_start_date,
      timer_visibility,
      link_url
    } = item;
    var dateNow = new Date();
    var dateEnd = new Date(promo_end_date);
    var timer_offset = isDST(dateNow) ? 4 : 5;
    dateEnd.setHours(dateEnd.getHours() + timer_offset);
    var dateStart = new Date(promo_start_date);
    dateStart.setHours(dateStart.getHours() + timer_offset);
    var timeIsNotOutOfBound = dateNow <= dateEnd && dateNow >= dateStart;
    var isShowTimer = timer_visibility && timeIsNotOutOfBound;
    return /*#__PURE__*/React.createElement("div", {
      key: record_id
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: bar_background_color,
        color: text_color
      },
      className: classes.promoBarContainers
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.promoBarWrapper
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.promoBarTitle
    }, promo_title), link_title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: classes.promoBarLine
    }, SEPARATOR), /*#__PURE__*/React.createElement("span", {
      className: classes.promoBarSaveNow
    }, /*#__PURE__*/React.createElement(BBLink, {
      forceNewTab: link_url.setting,
      to: resourceUrl(link_url.default)
    }, link_title)))), isShowTimer && /*#__PURE__*/React.createElement(PromoBarTimer, {
      dateEnd: dateEnd,
      dateNow: dateNow
    })));
  }))));
};
export default PromoBar;